import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Icon, Image, Menu, Label, Button, Popup } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { isSuperAdmin } from '../utils/user-profile';
import { logoutUser } from '../actions/login-actions';
import { soundsOnChange } from '../actions/to-do-actions';
import Can from './Can';

class LayoutHeader extends Component {

    render() {        
        if(this.props.user === null){//Opção para quando aplicação inicia e ainda não tem dados do user
            return(
                <Menu fixed='top' color='blue' inverted borderless size='tiny'>
                    <Container>
                        <Menu.Item as={ Link } to='/' header>
                            <Image
                                size='mini'
                                src='/EDPlogo_footer.png'
                            />         
                        </Menu.Item>
                    </Container>
                </Menu>
            )
        }else{
            //vars para verificar o que é mostrado consoante o utilizador, excepto super admin que ve tudo
            const companyProfile = this.props.user.profile.COMPANY + '-' + this.props.user.profile.PROFILE;
            const auxSAFlag = isSuperAdmin(this.props.user);
            return(
                <Menu fixed='top' color='blue' inverted borderless size='tiny' style={{overflow: 'auto'}}>
                    <Container>
                        <Menu.Item as={ Link } to='/' header>
                        <Image
                            size='mini'
                            src='/EDPlogo_footer.png'
                        />         
                        </Menu.Item>
                        <Can do="viewIDsHidroUNGE" on={companyProfile}>
                            <Menu.Item as={ Link } name='instr' to='/cent'>
                                <Icon name='tint' />
                                {auxSAFlag ? <FormattedMessage id="word.idHidroUNGE" /> : <FormattedMessage id="word.idHidro" />}
                            </Menu.Item>
                        </Can>
                        <Can do="viewIDsHidroPROD" on={companyProfile}>
                            <Menu.Item as={ Link } name='prod' to='/prod'>
                                <Icon name='tint' />
                                {auxSAFlag ? <FormattedMessage id="word.idHidroPROD" /> : <FormattedMessage id="word.idHidro" />}
                            </Menu.Item>
                        </Can>
                        <Can do="viewIDsHidroHist" on={companyProfile}>
                            <Menu.Item as={ Link } name='histo' to='/hist'>
                                <Icon name='bar chart' />
                                <FormattedMessage id="word.historicHidroShort" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewIDsTermUNGE" on={companyProfile}>
                            <Menu.Item as={ Link } name='instrTerm' to='/instrTerm'>
                                <Icon name='thermometer half' />
                                {auxSAFlag ? <FormattedMessage id="word.idTermUNGE" /> : <FormattedMessage id="word.idTerm" />}
                            </Menu.Item>
                        </Can>
                        <Can do="viewIDsTermPROD" on={companyProfile}>
                            <Menu.Item as={ Link } name='prodTerm' to='/prodTerm'>
                                <Icon name='thermometer half' />
                                {auxSAFlag ? <FormattedMessage id="word.idTermPROD" /> : <FormattedMessage id="word.idTerm" />}
                            </Menu.Item>
                        </Can>
                        <Can do="viewIDsTermHist" on={companyProfile}>
                            <Menu.Item as={ Link } name='histoTerm' to='/histTerm'>
                                <Icon name='bar chart' />
                                <FormattedMessage id="word.historicTermShort" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewCIs" on={companyProfile}>
                            <Menu.Item as={ Link } name='cis' to='/cis'>
                                <Icon name='inbox' />
                                <FormattedMessage id="word.ci" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewFIs" on={companyProfile}>
                            <Menu.Item as={ Link } name='fis' to='/fis'>
                                <Icon name='envelope' />
                                <FormattedMessage id="word.fi" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewIOs" on={companyProfile}>
                            <Menu.Item as={ Link } name='ios' to='/ios'>
                                <Icon name='announcement' />
                                <FormattedMessage id="word.io" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewCCs" on={companyProfile}>
                            <Menu.Item as={ Link } name='ccs' to='/ccs'>
                                <Icon name='inbox' />
                                <FormattedMessage id="word.cc" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewFCs" on={companyProfile}>
                            <Menu.Item as={ Link } name='fcs' to='/fcs'>
                                <Icon name='envelope' />
                                <FormattedMessage id="word.fc" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewToDoPTG" on={companyProfile}>
                            <Menu.Item as={ Link } name='todoindispsconds' to='/todoindispsconds'>
                                <Icon color={this.props.todo.length > 0 ? 'red' : 'blue'} name='circle' />
                                <FormattedMessage id="word.toDoShort" />
                            </Menu.Item>
                        </Can>                 
                        <Can do="viewCPs" on={companyProfile}>
                            <Menu.Item as={ Link } name='cps' to='/cps'>
                                <Icon name='inbox' />
                                <FormattedMessage id="word.cp" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewFPs" on={companyProfile}>
                            <Menu.Item as={ Link } name='fps' to='/fps'>
                                <Icon name='envelope' />
                                <FormattedMessage id="word.fp" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewPMs" on={companyProfile}>
                            <Menu.Item as={ Link } name='pms' to='/pms'>
                                <Icon name='file' />
                                <FormattedMessage id="word.pm" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewISs" on={companyProfile}>
                            <Menu.Item as={ Link } name='iss' to='/iss'>
                                <Icon name='announcement' />
                                <FormattedMessage id="word.is" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewToDoESP" on={companyProfile}>
                            <Menu.Item as={ Link } name='todoplansindisps' to='/todoplansindisps'>
                                <Icon color={this.props.todo.length > 0 ? 'red' : 'blue'} name='circle' />
                                <FormattedMessage id="word.toDoShort" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewCurrentIndCondPTG" on={companyProfile}>
                            <Menu.Item as={ Link } name='allfs' to='/allfs'>
                                <Icon name='world' />
                                <FormattedMessage id="word.allSheetsShort" />
                            </Menu.Item>
                        </Can>
                        <Can do="viewCurrentIndCondESP" on={companyProfile}>
                            <Menu.Item as={ Link } name='allfs' to='/allfs'>
                                <Icon name='world' />
                                <FormattedMessage id="word.allSheetsShort" />
                            </Menu.Item>
                        </Can> 
                        <Can do="viewUnits" on={companyProfile}>
                            <Menu.Item as={ Link } name='units' to='/units'>
                                <Icon name='industry' />
                                <FormattedMessage id="word.productionCenters" />
                            </Menu.Item>
                        </Can>
                        <Menu.Item position='right'>
                            <Can do="viewAlarms" on={companyProfile}>
                                <Popup trigger={<Button size='mini' color='blue' icon as={ Link } to='/alarms'><Icon name='list' /></Button>} content={<FormattedMessage id="word.alarms" />} />
                            </Can>
                            <Popup 
                                trigger={
                                    <Button size='mini' color='blue' icon onClick={()=>this.props.soundsOnChange()}>
                                        <Icon name={this.props.soundsOn === true ? 'alarm' : 'alarm mute'} color={this.props.soundsOn === true ? 'green' : 'black'} />
                                    </Button>
                                } 
                                content={
                                    <FormattedMessage id={this.props.soundsOn === true ? "message.soundOff" : "message.soundOn"} />
                                } 
                            />
                            <Label color='blue' size='tiny'>
                                <p>{this.props.user ? this.props.user.profile.USERNAME + '/' + this.props.user.profile.PROFILE: ''}</p>
                            </Label>
                            <Popup trigger={<Button size='mini' color='blue' icon onClick={()=>logoutUser()}><Icon name='log out' /></Button>} content='Log out' />
                        </Menu.Item>
                    </Container>
                </Menu>
            )
        }
    }
}
const mapStateToProps = (state) => {
    return {
        soundsOn: state.toDoStore.soundsOn,
        todo: state.toDoStore.finalList
    };
};  
export default connect(
    mapStateToProps, 
    {
        soundsOnChange
    }
)(LayoutHeader);


// WEBPACK FOOTER //
// ./src/components/layout-header.js